import * as React from 'react'

interface SettingsHiddenInputsProps {
  prefix: string
  settings?: Record<string, unknown>
}

export default function SettingsHiddenInputs({ prefix, settings }: SettingsHiddenInputsProps) {
  if (!settings) return null

  return (
    <>
      {Object.entries(settings).map(([key, value]) => {
        if (value === undefined || value === null || value === '') return null
        return (
          <input
            key={key}
            type="hidden"
            name={`${prefix}[settings][${key}]`}
            value={String(value)}
          />
        )
      })}
    </>
  )
}
